import React, { Component } from 'react';
import { translate } from 'react-i18next';

import './Button.css';

class Button extends Component {

  render() {
    const { text, active, onClick } = this.props;
    let style = {
      color: 'white',
      backgroundColor: '#027335',
    };

    if (active === false) {
      style.color = '#027335';
      style.backgroundColor = '#e6e6e6';
    }

    return (
      <div className='underListButton' onClick={active !== false ? onClick : undefined} style={style}>
        {text}
      </div>
    );
  }
}

export default translate()(Button);
